/**
 * 페이지 규격 상수
 * A4, A5 페이지 사이즈별 치수 정의
 */

export const PAGE_DIMENSIONS = {
  A4: {
    width: 794,
    height: 1122,
    verticalPadding: 70,
    horizontalPadding: 70,
    bindingInner: 70,
    bindingOuter: 70,
    footerHeight: 50,
    footerBottom: 45,
  },
  A5: {
    width: 559,
    height: 794,
    verticalPadding: 50,
    horizontalPadding: 45,
    bindingInner: 55, // 홀수페이지 좌측
    bindingOuter: 35, // 홀수페이지 우측
    footerHeight: 10,
    footerBottom: 30,
  },
};

/**
 * 콘텐츠 영역 높이 계산 (페이지 높이 - 상하 패딩 - 푸터 높이)
 * @param {string} pageSize - 'A4' 또는 'A5'
 * @returns {number} 콘텐츠 영역 높이 (px)
 */
export function getContentHeight(pageSize) {
  const dim = PAGE_DIMENSIONS[pageSize];
  return dim.height - dim.verticalPadding * 2 - dim.footerHeight;
}

/**
 * 콘텐츠 영역 너비 계산
 * @param {string} pageSize - 'A4' 또는 'A5'
 * @param {boolean} isOddPage - 홀수 페이지 여부
 * @returns {number} 콘텐츠 영역 너비 (px)
 */
export function getContentWidth(pageSize, isOddPage = true) {
  const dim = PAGE_DIMENSIONS[pageSize];
  if (pageSize === "A5") {
    return dim.width - dim.bindingInner - dim.bindingOuter;
  }
  return dim.width - dim.horizontalPadding * 2;
}

/**
 * 페이지별 좌우 여백 계산 (A5 제본 여백 고려)
 * @param {string} pageSize - 'A4' 또는 'A5'
 * @param {number} pageNumber - 페이지 번호
 * @returns {object} { paddingLeft, paddingRight }
 */
export function getPagePadding(pageSize, pageNumber) {
  const dim = PAGE_DIMENSIONS[pageSize];
  const isOddPage = pageNumber % 2 === 1;

  if (pageSize === "A5") {
    return {
      paddingLeft: isOddPage ? dim.bindingInner : dim.bindingOuter,
      paddingRight: isOddPage ? dim.bindingOuter : dim.bindingInner,
    };
  }

  return {
    paddingLeft: dim.horizontalPadding,
    paddingRight: dim.horizontalPadding,
  };
}
